import React from "react";
import GoogleMapContain from "../../Componant/Maps/GoogleMap";

const GoogleMap = () => {
  return (
    <div className="page-body">
      <GoogleMapContain />
    </div>
  );
};

export default GoogleMap;
